import React from "react";
import { Home, Route, Mountain, Umbrella, Fence, AppWindow, Building2, Droplets } from "lucide-react";

const SERVICES = [
  { icon: Home, title: "House Washing", desc: "Soft-wash siding, vinyl, stucco & brick — safe and thorough." },
  { icon: Route, title: "Driveways & Sidewalks", desc: "Lift years of dirt, oil, and stains from concrete & pavers." },
  { icon: Mountain, title: "Roof Cleaning", desc: "Specialized soft wash removes black streaks, algae, and lichen." },
  { icon: Umbrella, title: "Patios & Pool Decks", desc: "Restore that just-installed look around your favorite spaces." },
  { icon: Fence, title: "Fence Cleaning", desc: "Brighten weathered wood and vinyl fences in a single visit." },
  { icon: AppWindow, title: "Window Cleaning", desc: "Streak-free interior & exterior shine for residential & commercial." },
  { icon: Building2, title: "Commercial & Residential", desc: "Storefronts, HOAs, multi-unit, and family homes — we do it all." },
  { icon: Droplets, title: "Mold, Mildew & Algae", desc: "We eliminate growth at the root, protecting your surfaces." },
];

export default function Services() {
  return (
    <section id="services" className="py-20 md:py-28 bg-white" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <div className="font-script text-3xl text-[var(--fc-orange)]">What we wash</div>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold text-[var(--fc-blue-dark)] mt-1">
            We Wash It All.
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-slate-600 text-lg">
            Commercial &amp; residential exterior cleaning — based in St. Cloud and serving all of Central Florida. Soft-wash safe,
            insured, and guaranteed.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICES.map((s) => (
            <div
              key={s.title}
              className="group rounded-2xl bg-[var(--fc-surface)] border border-blue-100 p-6 hover:-translate-y-1 hover:shadow-xl hover:shadow-blue-900/10 transition-all duration-300"
              data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, '-')}`}
            >
              <div className="w-14 h-14 rounded-2xl btn-blue flex items-center justify-center mb-5 bob">
                <s.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="font-heading text-xl font-bold text-[var(--fc-blue-dark)]">{s.title}</h3>
              <p className="mt-2 text-slate-600 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
